<template>
<div class="container">
    <div class="detailcontent relative">
        <div class="listbg">
            <h1>{{bookListInfo.name}}</h1>
            <div class="total">共 {{bookListInfo.sumCount}} 本书</div>
            <!-- <div class="ludubis">{{bookListInfo.buyPrice}}</div> -->
<!--            <div>
                <a class="buyBtns" v-if="bookListInfo.listType == 3" href="https://a.app.qq.com/o/simple.jsp?pkgname=com.auto.learning" target="_blank">请下载app购买后收听</a>
                <div v-else>
                    <button class="buyBtns" v-if="bookListInfo.canBuy==1" @click="$store.commit('showVipQrcode')">开通VIP会员</button>
                </div>
            </div> -->
        </div>
        <img class="faceImg" :src="bookListInfo.faceImg | objs" />

    </div>
    <div class="detailcontent relative">
        <span class="yinhao">“</span>
        <div class="intro" v-html="bookListInfo.intro"></div>
    </div>
    <div class="detailcontent" v-if="bookListInfo.listType == 3 & bookListInfo.canBuy == 1 || bookListInfo.canBuy == 0 ">
        <div class="h100"></div>
        <div class="f20 mleftright">书单目录<span class="sumCount">共 {{bookListInfo.sumCount}} 本书</span></div>
        <div class="mleftright" v-for="(item,index) in bookList" :key="index">
            <ms-list-item v-bind:books="item"></ms-list-item>
        </div>
    </div>
    <div class="detailcontent" v-else>
        <div class="h100"></div>
        <div class="f20 mleftright">书单目录<span class="sumCount">共 {{bookListInfo.sumCount}} 本书</span><button class="play-all" @click="playAll">▶ 播放全部</button></div>
        <div class="mleftright" v-for="(item,index) in bookList" :key="index">
            <sd-list-item v-bind:books="item"></sd-list-item>
        </div>
    </div>
    <div class="height30"></div>
</div>
</template>

<script>
import SdListItem from '@/components/SdListItem'
import MsListItem from '@/components/MsListItem'
import {getCookie} from '@/network/cookie.js'
export default {
    metaInfo() {
        return{
        title: this.bookListInfo.name+'--路上畅听书单专辑',
        meta: [
          { vmid: 'keywords', name: 'keywords', content: this.$store.state.keywords },
          { vmid: 'description', name: 'description', content: this.$store.state.description }
        ] 
        }
    },
    data() {
        return {
            bookListInfo: {},
            bookList: {},
            listId: this.$route.query.listId,
            sessionId:getCookie('sessionId')
        }
    },
    name: 'BookList',
    components: {
        SdListItem,
        MsListItem
    },
    created: function () {
        
        this.getBookListInfo();
        this.getBookList();
    }, 
    methods: {
        getBookListInfo: function () { 
            this.$http.get({
                url: 'xcx/book-list-info' + '?listId=' + this.listId + '&sessionId='+this.sessionId
            }).then(res => {
                this.bookListInfo = res.data.data;

            })
        },
        getBookList: function () {  
            this.$http.get({
                url: 'xcx/book-list-detail' + '?listId=' + this.listId+'&sessionId='+this.sessionId
            }).then(res => {
                this.bookList = res.data.data;

            })
        },
        playAll:function(){ 
            this.$store.dispatch('playbooklist', this.bookList) 
        }, 
    }
}
</script>

<style scoped>
a{text-decoration: none;}
.relative {
    position: relative;
}

.listbg {
    background-image: url('../assets/booklistbg.png');
    background-repeat: repeat-x;
    background-size: 1 400px;
    background-position: center bottom;
    height: 440px;
    position: absolute;
    top: 30px;
    left: 0;
    right: 0;
    z-index: 3;
    text-align: center;
}

.listbg h1 {
    font-size: 26px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: #242A27;
    padding-top: 260px;
    margin-bottom: 0px;
}

.listbg .total {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #242A27;
    line-height: 24px;
    margin-bottom: 20px;
}

.listbg .ludubis {
    font-size: 14px;
    padding-right: 70px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(155, 166, 166, 1);
    height: 22px;
    background-image: url(https://objs.auto-learning.com/xcximages/bi3x.png);
    background-position: right top;
    background-repeat: no-repeat;
    background-size: 70px 19px;
    display: inline-block;
    margin-bottom: 10px
}

.buyBtns {
    padding: 5px 50px;
    background: #4CCCAA;
    border-radius: 2px;
    border: 1px solid #4CCCAA;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #FFFFFF;
    cursor: pointer;
}

.buyBtns:hover {
    background: rgb(23, 196, 150);
}

.mb10 {
    margin-bottom: 10px;
}

.midbg {
    background: rgba(249, 249, 249, 1);
    margin: 0;
    padding: 0;
}

.detailcontent {
    overflow: hidden;
}

.faceImg {
    width: 100%;
    float: left;
    margin-top: 30px;
}

.f26 {
    font-size: 26px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(36, 41, 38, 1);
    line-height: 60px;
}

.f20 {
    font-size: 20px;
    font-family: Source Han Serif CN;
    font-weight: bold;
    color: rgba(36, 41, 38, 1);
    padding-bottom: 10px;
    line-height: 24px;
}

.f16 {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: rgba(155, 166, 166, 1);
}

.h100 {
    height: 100px;
}

.intro {
    margin: 20px 130px;
    font-size: 18px;
    font-family: Source Han Serif CN;
    font-weight: 500;
    color: rgba(36, 41, 38, 1);
    line-height: 30px;
}

.intro p {
    margin: 0 !important;
    padding: 0;
}

.relative {
    position: relative;
}

.relative .yinhao {
    font: italic 14px/16px "黑体";
    text-indent: 3em;
    color: rgba(225, 228, 228, 1);
}

.relative .yinhao:first-of-type {
    font: 84px "黑体";
    position: absolute;
    left: -170px;
}

.relative .yinhao:last-of-type {
    font: 84px "黑体";
    position: absolute;
    right: -38px;
}

.mleftright {
    margin: 0 100px;
}

.sumCount {
    padding: 0px 10px;
    margin-left: 20px;
    display: inline-block;
    background: rgba(75, 204, 170, 0.1);
    font-size: 12px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(75, 204, 170, 1);
}
.play-all{float: right; background: #4CCCAA; color: #FFFFFF; border: none; padding: 5px 20px; border-radius: 3px;}
.play-all:hover{background: rgb(23, 196, 150);}
</style>
